import React from 'react';
import SeoHead from '../components/SeoHead';
import BookingForm from '../components/BookingForm';

export default function ContactPage() {
  return (
    <>
      <SeoHead
        title="Kontakt os | Uforpligtende dialog om SoMe & Content"
        description="Kontakt Myserviceforyou for en uforpligtende snak om jeres sociale medier, content-redigering, Meta-postkalender og online vejledning. 0 binding."
      />

      {/* Hero & Contact Section */}
      <section className="pt-40 pb-20 md:pt-48 lg:pt-52 md:pb-28 bg-[#FAF8F5] border-b border-[#E8E2D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            {/* Left Info Column */}
            <div className="lg:col-span-5 space-y-8">
              <div className="space-y-4">
                <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EAE4DC] text-xs font-semibold uppercase tracking-wider text-[#161514]">
                  Sparring · Redigering · Synlighed
                </span>
                <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-[#161514] leading-tight">
                  Lad os tage en snak om jeres{' '}
                  <span className="text-[#876F50]">sociale medier</span>
                </h1>
                <p className="text-base text-[#5C5852] leading-relaxed">
                  Hver forretning er forskellig, og vi har derfor ingen faste prispakker. Vi sammensætter en fleksibel aftale med 0 binding, der passer præcist til dit behov.
                </p>
              </div>

              {/* Campaign Highlight */}
              <div className="p-5 rounded-2xl bg-[#161514] text-white space-y-2 shadow-sm">
                <div className="flex items-center gap-2 text-[#C5A880] text-xs font-bold uppercase tracking-wider">
                  <i className="fa-light fa-gift" aria-hidden="true" />
                  <span>Aktuel kampagne</span>
                </div>
                <p className="text-sm font-semibold text-[#FAF8F5]">
                  Betal for 2 måneder – få 1 måned helt gratis!
                </p>
                <p className="text-xs text-[#B8B0A5] leading-relaxed">
                  Gælder alle nye samarbejder uden binding. Oplev værdien af kontinuerligt, professionelt content på jeres profiler.
                </p>
              </div>

              {/* Direct Info Cards */}
              <div className="space-y-6 pt-2">
                <div className="space-y-1">
                  <p className="text-xs uppercase tracking-widest text-[#8C867D] font-semibold">
                    Telefon
                  </p>
                  <a
                    href="tel:+4561489206"
                    className="text-xl font-bold text-[#161514] hover:text-[#876F50] transition-colors no-break block"
                  >
                    +45 61 48 92 06
                  </a>
                  <p className="text-xs text-[#7A746B]">
                    Hverdage fra kl. 08:00 – 17:00
                  </p>
                </div>

                <div className="space-y-1">
                  <p className="text-xs uppercase tracking-widest text-[#8C867D] font-semibold">
                    Email
                  </p>
                  <a
                    href="mailto:info.myserviceforyou@gmail.com"
                    className="text-xl font-bold text-[#161514] hover:text-[#876F50] transition-colors no-break block"
                  >
                    info.myserviceforyou@gmail.com
                  </a>
                  <p className="text-xs text-[#7A746B]">
                    Vi besvarer alle henvendelser inden for 24 timer
                  </p>
                </div>

                <div className="space-y-1">
                  <p className="text-xs uppercase tracking-widest text-[#8C867D] font-semibold">
                    Format & Samarbejde
                  </p>
                  <p className="text-base font-semibold text-[#161514]">
                    Sparring & Redigering · Hele landet
                  </p>
                  <p className="text-xs text-[#7A746B]">
                    CVR: <span className="no-break font-medium text-[#161514]">46 69 75 53</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Right Form Column */}
            <div className="lg:col-span-7">
              <BookingForm formType="contact" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
